import { z } from "zod";
import { createApiResponseSchema } from "../common/pagination";
import {
  LegalSchema,
  type AttributeSchema,
  type UpdateLegalShema,
} from "@/schemas/legal";

export type ItemsType = {
  label: string;
  onClick: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
};

export const pageTypesConst = {
  policies: "policies",
  terms: "terms",
} as const;

export type PageTypes = (typeof pageTypesConst)[keyof typeof pageTypesConst];

export const editTypesEnum = {
  visual: "visual",
  html: "html",
} as const;

export type EditTypesEnum = (typeof editTypesEnum)[keyof typeof editTypesEnum];

export type LegalInfoFilters = {
  filter?: {
    active?: boolean;
  };
};

export type LegalType = z.infer<typeof LegalSchema>;

export type LegalAttributeType = z.infer<typeof AttributeSchema>;

export type UpdateLegalType = z.infer<typeof UpdateLegalShema>;

// export const CreateLegalSchema = AttributeSchema.omit({ id: true });
export const CreateLegalSchema = z.object({ content: z.string() });
export type CreateLegalType = z.infer<typeof CreateLegalSchema>;

export const ApiLegalResponseSchema = createApiResponseSchema(LegalSchema);
export type ApiLegalResponseType = z.infer<typeof ApiLegalResponseSchema>;
